document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mt-resenas]').forEach(initResenasCarrusel);
});

function initResenasCarrusel(contenedor) {
  var track = contenedor.querySelector('[data-mt-resenas-track]');
  if (!track || track.getAttribute('data-mt-listo')) return;
  track.setAttribute('data-mt-listo', '1');

  var tarjetasOriginales = Array.prototype.slice.call(track.children);
  if (!tarjetasOriginales.length) return;

  tarjetasOriginales.forEach(function (tarjeta) {
    var copia = tarjeta.cloneNode(true);
    copia.setAttribute('aria-hidden', 'true');
    copia.setAttribute('tabindex', '-1');
    track.appendChild(copia);
  });

  var velocidad = parseFloat(contenedor.getAttribute('data-mt-velocidad')) || 40;
  var mitad = 0;
  var pxPorSegundo = 0;
  var pausado = false;
  var arrastrando = false;
  var inicioX = 0;
  var inicioScroll = 0;

  function calcularMitad() {
    mitad = track.scrollWidth / 2;
    pxPorSegundo = velocidad > 0 ? mitad / velocidad : 0;
  }
  calcularMitad();
  window.addEventListener('resize', calcularMitad);

  function normalizar() {
    if (mitad <= 0) return;
    if (contenedor.scrollLeft >= mitad) {
      contenedor.scrollLeft -= mitad;
    } else if (contenedor.scrollLeft < 0) {
      contenedor.scrollLeft += mitad;
    }
  }

  var ultimoTiempo = null;
  function animar(tiempo) {
    if (ultimoTiempo === null) ultimoTiempo = tiempo;
    var delta = (tiempo - ultimoTiempo) / 1000;
    ultimoTiempo = tiempo;
    if (!pausado && !arrastrando) {
      contenedor.scrollLeft += pxPorSegundo * delta;
      normalizar();
    }
    requestAnimationFrame(animar);
  }
  requestAnimationFrame(animar);

  contenedor.addEventListener('mouseenter', function () { pausado = true; });
  contenedor.addEventListener('mouseleave', function () { pausado = false; });

  function mover(evento) {
    var delta = evento.clientX - inicioX;
    contenedor.scrollLeft = inicioScroll - delta;
    normalizar();
  }

  function soltar() {
    arrastrando = false;
    contenedor.classList.remove('mt-resenas-arrastrando');
    document.removeEventListener('mousemove', mover);
    document.removeEventListener('mouseup', soltar);
    window.removeEventListener('blur', soltar);
  }

  contenedor.addEventListener('mousedown', function (evento) {
    arrastrando = true;
    inicioX = evento.clientX;
    inicioScroll = contenedor.scrollLeft;
    contenedor.classList.add('mt-resenas-arrastrando');
    document.addEventListener('mousemove', mover);
    document.addEventListener('mouseup', soltar);
    window.addEventListener('blur', soltar);
  });

  // Red de seguridad: si por algún motivo el mouse queda "apretado" o el
  // hover queda pegado (cambio de pestaña, etc.), se libera solo.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      soltar();
      pausado = false;
    }
  });
}
